import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { saveAs } from "file-saver";
@Component({
  selector: "app-tpm",
  templateUrl: "./tpm.component.html",
  styleUrls: ["./tpm.component.css"]
})
export class TPMComponent implements OnInit {
  duplicateStatus: boolean = false;
  actionmode: string = "Seacrh";
  search_result_list: any = [];
  totalItems: number = 1;
  p: number = 1;
  deleteid = "";
  showList: boolean = false;
  editFlag: any = false;
  screen_details: any = [];
  search_details: any = [];
  searchlist: boolean = true;
  duplicateList: any = [];
  loader: any = false;
  searchresult = false;
  parent_table = "tpm_master";
  screentitle: string = "TPM Master";
  childtables = [];
  EditData: any = [];
  filters = [];
  serachtabledata: any = [];
  viewpage = false;
  header: any = [];
  data: any = [];
  constructor(
    private vernostService: VernostServiceService
    ) { }

  ngOnInit() { }

  addForm() {
    document.getElementById("errs").innerHTML = "";
    this.actionmode = "Add";
    this.showList = false;
  }


  searchForm() {
    this.screen_details = [];
    this.search_details = [];
    this.serachtabledata = [];
    this.editFlag = false;
    document.getElementById("errs").innerHTML = ""
    this.searchresult = false;
    this.viewpage = false;
    this.actionmode = "Search";
  }

  submitData1() {
    //console.log("this.screen_details", this.screen_details);

    var id = "";
    if (this.EditData.length > 0) {
      id = this.EditData[0]["tpm_master_id"]
    }
    var origin = this.screen_details.Origin_Code;
    var destination = this.screen_details.Destination_Code
    var TPMArray = {
      ID: id,
      OriginCode: origin.toUpperCase(),
      DestinationCode: destination.toUpperCase(),
      TPMValue: this.screen_details.TPM_Value
    };
    console.log("TPMArray", TPMArray);
    if (this.editFlag == false) {
      this.vernostService.InsertTpmArray(TPMArray).subscribe(response => {
        //console.log("TPMResponce:-", response);
        if (response["status"] == "failure") {
          console.log("in if");
          this.screen_details.TPM_Value = response["TPM"];
          document.getElementById("errs").innerHTML = response["message"];

        } else {
          console.log("in else");
          document.getElementById("errs").innerHTML = "Record inserted successfully";
          this.screen_details = [];
        }
      });
    }
    if (this.editFlag == true) {

      //console.log("EditData="+this.EditData[0]["tpm_master_id"]);
      //console.log("this.EditData="+JSON.stringify(this.EditData));
      this.vernostService.UpdateTpmArray(TPMArray).subscribe(response => {
        //console.log("TPMUpdateResponce:-", response);
        if (response != undefined) {
          document.getElementById("errs").innerHTML = "Record Updated Successfully"
          this.screen_details = [];
        } else {
          document.getElementById("errs").innerHTML = "Record Not Updated Successfully"
        }

      });
    }

  }

  searchData() {
    this.duplicateStatus = false;
    this.searchlist = false;
    this.loader = true;
    var field1 = this.search_details.Origin_Code;
    var field2 = this.search_details.Destination_Code;
    var field3 = this.search_details.TPM_Value;
    if (
      (field1 == "" || field1 == undefined) &&
      (field2 == "" || field2 == undefined) &&
      (field3 == "" || field3 == undefined)
    ) {
      this.serachtabledata = [];
      var data = {
        pagination: this.p
      }
      this.vernostService.searchTPMRecord(data).subscribe(response => {
        var searchData = response;
        var count = searchData[0].count;
        this.totalItems = count;
        this.search_result_list = searchData[0].result;
        this.serachtabledata = this.search_result_list;
        if (this.serachtabledata.length > 0) {
          this.searchresult = true;
          this.loader = false;
          document.getElementById("errs").innerHTML = "";
        } else {
          this.searchresult = false;
          document.getElementById("errs").innerHTML = "Record not found";
        }

      });
    } else {
      this.serachtabledata = [];
      if(field1 != undefined && 
        field1.trim() != "") {
        var fields1 = field1.toUpperCase();
      }

      if(field2 != undefined && 
        field2.trim() != "") {
        var fields2 = field2.toUpperCase();
      }

      var searchColumn = [];
      var searchitem = [];

      if(field1 != "" && 
      field1 != undefined) {
        searchitem.push(fields1);
        searchColumn.push("origin");
      }
      if(field2 != "" && 
      field2 != undefined) {
        searchitem.push(fields2);
        searchColumn.push("destination");
      }
      
      if(field3 != "" && 
      field3 != undefined) {
        searchitem.push(field3);
        searchColumn.push("tpm_value");
      }

      var searchRecordData = {
        parent_table: this.parent_table,
        dbFields: searchColumn,
        searchData: searchitem,
        childtables: this.childtables,
        filters: this.filters
      };
      this.vernostService.searchRecord(searchRecordData).subscribe(response => {
        this.loader = false;
        this.serachtabledata = response;
        if(response !== null && response !== undefined){
          this.totalItems = response.length;
        }
        if (response.length > 0) {
          this.searchresult = true;
          this.serachtabledata = response;
          document.getElementById("errs").innerHTML = "";
        } else {
          this.searchresult = false;
          document.getElementById("errs").innerHTML = "Record not found";
        }
      });
    }
  }

  showFormData(data, flag) {
    this.EditData = [];
    this.deleteid = "";
    this.EditData.push(data);
    console.log("dattttttfffff", this.EditData);

    if (flag == 1) {
      this.editFlag = false;
      this.actionmode = "view";
      this.viewpage = true;


    } else {
      this.deleteid = this.EditData[0].tpm_master_id;
      // console.log(id);
      this.editFlag = true;
      // alert("viwe data"+this.editFlag);
      this.actionmode = "Edit";
      this.screen_details.Origin_Code = data.origin;
      this.screen_details.Destination_Code = data.destination;
      this.screen_details.TPM_Value = data.tpm_value;
      // console.log("aa",data.origin);
      // console.log("bb",this.screen_details.Destination_Code);
      // console.log("cc",this.screen_details.TPM_Value);
    }

  }

  getReprt() {
    this.loader = true;
    this.vernostService.downloadTPMFile().subscribe(
      result => {
        console.log("result", result.size);
        // this.noresult = "";
        if (result.size != 0) {
          saveAs(result, "TPM.csv");
        } else {
          // this.noresult = "Result Not Found";
        }
        this.loader = false;
      },
      err => { }
    );
  }

  // deleteid
  Delete() {
    let Data = {
      id: this.deleteid
    }
    this.vernostService.DeleteTPMRecord(Data).subscribe(response => {
      let result = response;
      if (result["status"] = "Success") {
        document.getElementById("errs").innerHTML = "Record Successfully Deleted";
        this.searchForm();
      } else {
        document.getElementById("errs").innerHTML = "Record Not Successfully Deleted";
      }
      // console.log("Deleteresponse",response);

    });

  }


  pageCount(count) {
    this.p = count;
    this.searchData()
    console.log("P:::", this.p);
  }


  Upload() {
    document.getElementById("attachment").click();
  }

  fileSelected(val) {
    this.loader = true;

    var file = val.target.files[0];
    console.log("filename", file);
    var filename = file.name.toString().split(".")
    console.log("filename===========>", filename);
    if (filename[1] === "csv") {
      document.getElementById("errs").innerText = "";
      var reader = new FileReader();
      reader.readAsText(file);
      reader.onload = (data) => {
        //console.log("hiiiiiiii",reader.result);
        var cols = reader.result.toString().split(/\n|\r\n|\r/);
        //console.log(cols);
        for (let i = 0; i < cols.length - 1; i++) {
          if (i == 0) {
            this.header.push(cols[i].split(","));
            //console.log("header",this.header);
          } else {
            this.data.push(cols[i].split(","));
          }

        }
        let body = {};
        body["header"] = this.header;
        body["content"] = this.data;

        this.vernostService.submitTpmMaster(body).subscribe(
          result => {
            this.loader = false;
            console.log("result", result);
            // this.noresult = "";

            saveAs(result, "TPMR.csv");


            //       // this.noresult = "Result Not Found";
            this.loader = false;
            document.getElementById("errs").innerText = "your file is downloaded u can view it";
            val.target.value = "";
            this.header = [];
            this.data = [];
          },
          err => { }

        )

      }
    } else {
      this.loader = false;
      document.getElementById("errs").innerText = "Please Select .csv File";
      val.target.value = "";
    }

  }

  downloadFile() {
    let link = document.createElement("a");
    link.download = "sample.csv";
    link.href = "assets/csv/sample.csv";
    link.click();
  }

  listDuplicates() {
    //this.duplicateStatus = true;
    this.searchresult = false;
    this.duplicateList = [];
    this.vernostService.getDupliactes().subscribe((result) => {
      //console.log(result);
      if (result) {
        for (var i in result) {
          this.duplicateList.push(result[i]);
        }
        this.duplicateStatus = true;
      }
    })
  }
}